<template>
  <div class="lisence-bd tb" v-if="funcView.locationRecord_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item
          style="float: right; "
          v-if="funcView.locationRecord_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_locationRecord.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_locationRecord.he_tong_bian_hao')">
            <el-input v-model="formSearch.contractNo" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_locationRecord.xxmmc')">
            <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_locationRecord.jxmmc')">
            <el-input v-model="formSearch.oldLocationName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_locationRecord.ku_cun_fang')">
            <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_locationRecord.bian_geng_shi_jian')">
          <custom-date-picker
            v-model="formSearch.timer"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
          <el-form-item :label="$t('dms_locationRecord.cao_zuo_zu_zhi')">
            <el-input v-model="formSearch.operatorOrgName" placeholder="" style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange"  >
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'locationRecord',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'locationRecord',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        contractNo: '',
        orgName: '',
        operatorOrgName: '',
        timer: '',
        operateStartTime: '',
        operateEndTime: '',
        locationName: '',
        oldLocationName: '',
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.operateStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : null;
      this.formSearch.operateEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : null;
      this.$getJSON(apis.deviceLocationChangePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.deviceLocationChangeExport, this.formSearch).then(() => { });
    },

  },
};
</script>

<style lang="scss"></style>
